import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "./TimetableTab.css";
import { week } from "../../../../../../Components/Data/Weeks";

class TimetableTab extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Paper style={{ backgroundColor: "#181818" }}>
        <div className={classes.sectionDesktop}>
          <Tabs
            variant="fullWidth"
            value={this.props.currentTab}
            onChange={this.props.handleCurrentPage}
            TabIndicatorProps={{ style: { background: "#ffd31a" } }}
            style={{ outline: "none" }}
          >
            {week.map((week, index) => (
              <Tab
                key={index}
                label={week}
                value={week}
                classes={{
                  root: classes.root,
                  selected: classes.selectedStyle,
                }}
                className={classes.navStyle}
                disableRipple
              />
            ))}
          </Tabs>
        </div>
        <div className={classes.sectionMobile}>
          <Tabs
            variant="fullWidth"
            orientation="vertical"
            value={this.props.currentTab}
            onChange={this.props.handleCurrentPage}
            TabIndicatorProps={{ style: { background: "#ffd31a" } }}
          >
            {week.map((week, index) => (
              <Tab
                key={index}
                label={week}
                value={week}
                classes={{
                  root: classes.root,
                  selected: classes.selectedStyle,
                }}
                className={classes.tabs}
                disableRipple
              />
            ))}
          </Tabs>
        </div>
      </Paper>
    );
  }
}

export default withStyles(useStyles)(TimetableTab);
